import React from 'react';
import { Link } from 'react-router-dom';
import { Icon } from '../Icon';
import * as S from './ButtonClean.styled';
const getComponent = ({ to, href }) => {
    if (to)
        return Link;
    if (href)
        return 'a';
    return 'button';
};
export const ButtonClean = ({ appearance = 'primary', ariaLabel, analyticsKey, to, state, href, target, label, title, icon, withUnderline = true, disabled = false, type = 'button', onClick, }) => (React.createElement(S.Button, { "$appearance": appearance, as: getComponent({ to, href }), to: to, state: state, href: href, target: target, title: title, "$withUnderline": withUnderline, disabled: disabled, onClick: onClick, type: type, "aria-label": ariaLabel, "data-testid": "ButtonClean", "data-analytics": analyticsKey },
    icon && React.createElement(Icon, { component: icon, height: 12, ariaHidden: true }),
    label));
//# sourceMappingURL=ButtonClean.js.map